import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { FaRegCopy, FaCheck } from "react-icons/fa";

export default function CopyButton({ textToCopy, size = "sm", label = "Copy" }) {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(textToCopy);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
    };

    return (
        <Button
            className="url-copy-b d-flex align-items-center !flex whitespace-nowrap"
            variant="outline-secondary"
            size={size}
            onClick={handleCopy}
            style={{ gap: "6px", padding: "6px 12px", fontSize: "0.875rem" }}
        >
            {copied ? <FaCheck style={{ verticalAlign: "middle" }} /> : <FaRegCopy style={{ verticalAlign: "middle" }} />}
            {copied ? "Copied!" : label}
        </Button>
    );
}
